import React from 'react';
import { Box, Chip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { StatementScheduledEmail } from '../model';
import { attachmentsWithheld, scheduleStatusChip } from '../utils';
import { scheduledEmailTooltipProps } from '../../../scheduledEmails/components/ScheduledEmailTableTooltip';

interface Props {
  row: StatementScheduledEmail;
}

const StatementScheduleStatusCell: React.FC<Props> = ({ row }) => {
  const status = scheduleStatusChip(row);
  const withheld = attachmentsWithheld(row);
  const withheldTooltip = `Attachments withheld — ${row.matched_pdf_count} of ${row.debit_invoice_count} invoices`;

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      <span {...scheduledEmailTooltipProps(status.tooltip)} style={{ display: 'inline-flex' }}>
        <Chip label={status.label} color={status.color} size="small" variant="outlined" aria-label={status.tooltip} />
      </span>
      {withheld && (
        <span {...scheduledEmailTooltipProps(withheldTooltip)} style={{ display: 'inline-flex' }}>
          <WarningAmberIcon fontSize="small" color="warning" aria-label={withheldTooltip} />
        </span>
      )}
    </Box>
  );
};

export default StatementScheduleStatusCell;
